import { Equal, IQueryCommandOptions, Not } from '@llws/dynamic-router-utils';
import { IFloorplanNavigatorPresetCardGroups } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_preset_card_groups';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'id',
    'fpnPresetId',
    'label',
    'status',
  ],
  alias: 'f',
  where: [ Not(Equal('status', 'deleted')) ],
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'id',
    'fpnPresetId',
    'label',
    'status',
  ],
  alias: 'fnpf',
  where: [ Not(Equal('status', 'deleted')) ],
};
const base = new StoreBaseImplementationV2<Partial<IFloorplanNavigatorPresetCardGroups>>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
